import * as _ from "lodash-es";
import { countOutgoingSMSSegments } from "./utils";

export default {
  namespaced: true,
  state: {
    smsSegments: 0, // Number of sms segments available for the account
    templatesMap: {},
    smsMap: {},
    smsSettingsByPhone: {},
  },
  mutations: {
    setTemplates: function (state, templates) {
      state.templatesMap = _.keyBy(templates, "id");
    },
    updateTemplate: function (state, template) {
      state.templatesMap = {
        ...state.templatesMap,
        [template.id]: template,
      };
    },
    addSMSMessages(state, messages) {
      state.smsMap = {
        ...state.smsMap,
        ..._.keyBy(messages, "id"),
      };
    },
    setSMSSegments(state, segments) {
      state.smsSegments = segments;
    },
    recalculateSMSSegments(state, messages) {
      // Substract number of segments of outgoing messages.
      state.smsSegments -= countOutgoingSMSSegments(messages);
    },
    updatePhoneNumberSMSSettings(state, settings) {
      state.smsSettingsByPhone = {
        ...state.smsSettingsByPhone,
        [settings.mobile_phone]: settings,
      };
    },
  },
  getters: {
    templatesList(state) {
      return _.sortBy(Object.values(state.templatesMap), "name");
    },
    templatesOptions(state, getters) {
      return getters.templatesList.map((t) => ({ value: t.id, text: t.name }));
    },
    smsByPhone(state) {
      return _.groupBy(_.values(state.smsMap), "mobile_phone");
    },
  },
};
